import './single_product_modal.css';
import { useEffect, useState } from "react";
import { CloseIcon } from "../../assets/icons/CloseIcon";
import { useSingleProduct } from "../../context/SingleProductContext";
import { SpinnerLoader } from "../SpinnerLoader/SpinnerLoader";
import { serverEnv } from '../../env';
import { ProductQty } from '../ProductQty/ProductQty';
import { ProductNote } from '../ProductNote/ProductNote';
import { ProductOptionType } from '../../Enum/ProductOptionType';
import { ProductSelection } from '../ProductSelection/ProductSelection';
import { ProductExtra } from '../ProductExtra/ProductExtra';

export const SingleProductModal = () => {
    //HOOKS
    const {
        singleProduct: product,
        setSingleProduct,
        total,
        actionCreate,
        postAction,
        loading,
        errorMsg,
    } = useSingleProduct();

    //STATES
    const [imageUrl, setImageUrl] = useState("");

    //FUNCTIONS
    const close = () => {
        setSingleProduct(null);
    }

    //EFFECTS
    useEffect(() => {
        if (product !== null)
        {
            if (product.media.main_image !== "")
            {
                setImageUrl(serverEnv.backend + "/" + product.media.main_image);
            }
            else
            {
                setImageUrl("");
            }
        }
        else
        {
            setImageUrl("");
        }
    }, [product]);

    return (
        <>
            <div className={product !== null ? 'product_modal active' : 'product_modal'}>
                <div className={imageUrl !== "" ? 'product_modal_container img' : 'product_modal_container'}>
                    <button className='close' onClick={close}>
                        <CloseIcon />
                    </button>
                    <div className='product_modal_main_container'>
                        <div className='product_information'>
                            <div className='img'>
                                <img src={imageUrl} alt="" />
                            </div>
                            <div className='product_information_main'>
                                <h2 className='product_modal_title'>
                                    {product && product.name}
                                </h2>
                                <span className='product_modal_price'>
                                    ${product && product.pricing.price / 100}
                                </span>
                            </div>
                            <div className='product_modal_description'>
                                {product && product.description}
                            </div>
                        </div>
                        <div className='product_variations'>
                            {
                                product && product.options.options.map((option, index) => {
                                    if (option.type === ProductOptionType.SELECTION) {
                                        return (
                                            <ProductSelection
                                                option={option}
                                                key={'product_' + product.id + '_option_' + option.id}
                                            />
                                        );
                                    } else if (option.type === ProductOptionType.EXTRA)
                                    {
                                        return (
                                            <ProductExtra
                                                option={option}
                                                key={'product_' + product.id + '_option_' + option.id}
                                            />
                                        );
                                    }
                                })
                            }
                            <ProductNote />
                            <h2 className='error_msg'>
                                {errorMsg}
                            </h2>
                        </div>
                    </div>
                    <div className='footer'>
                        <ProductQty />
                        <div className='product_modal_submit_btn' onClick={postAction}>
                            <div className='loader active'>
                                {
                                    loading && (
                                        <SpinnerLoader />
                                    )
                                }
                            </div>
                            <h2>
                                {
                                    actionCreate ? "Add to cart" : "Update"
                                }
                            </h2>
                            <span className='divider'></span>
                            <span className='product_modal_total_price'>
                                ${total / 100}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
